import React from 'react';
import type { DonationForm } from '@kuow/core';

export const InitialDataContext = React.createContext<DonationForm | null>(null);
